<template>
  <div class="ds-checkbox">
    <label :for="id">
      {{ label }}
      <input
        type="checkbox"
        :id="id"
        ds-component="DsCheckbox"
        :indeterminate.prop="indeterminate"
        :disabled="disabled"
        :checked="value"
        v-bind="$attrs"
      />
      <span class="checkmark"></span>
    </label>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import Tokens from '@ds/tokens';

export default Vue.extend({
  name: 'DsCheckbox',
  props: {
    id: {
      type: String,
      required: false
    },
    label: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    indeterminate: {
      type: Boolean,
      required: false,
      default: false
    },
    value: {
      type: Boolean,
      required: false,
      default: false
    },
    dark: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mounted() {
    document.documentElement.setAttribute('data-color-theme', this.dark ? 'dark' : '');
  }
});
</script>

<style lang="scss" scoped>
@import '~@ds/styles/Checkbox.scss';
</style>
